(function () {
    "use strict";

    angular
        .module("app")
        .directive("patternNameSearchHelp", ["SearchFactory", patternNameSearchHelp]);

    function patternNameSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.patternNameKey = "";
                        scope.patternName = "";
                        scope.patternDesc = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.patternName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.patternNameSearch(function (patternName) {
                        scope.patternNameKey = patternName ? patternName.PatternNameKey : "";
                        scope.patternName = patternName ? patternName.PatternName : "";
                        scope.patternDesc = patternName ? patternName.Description : "";
                        scope.displayValue = scope.patternName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("patternName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.patternName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { patternNameKey: "=", patternName: "=?", patternDesc: "=?", readOnly: "=", needToValidate: "=?", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

